import React, { createContext, ReactNode, useContext } from 'react';
import { useAnalyticsService } from '../hooks/useAnalytics';

interface AnalyticsContextType {
  isLoading: boolean;
  hasConsent: boolean;
  setConsent: (consent: boolean) => void;
  trackPageView: (path?: string) => void;
}

// Définir la valeur par défaut pour le contexte
const defaultContextValue: AnalyticsContextType = {
  isLoading: false,
  hasConsent: false,
  setConsent: () => {
  },
  trackPageView: () => {
  }
};

// Créer le contexte avec une valeur par défaut
export const AnalyticsContext =
  createContext<AnalyticsContextType>(defaultContextValue);

// Provider à placer à la racine de l'application
export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  const analytics = useAnalyticsService();

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};

// Hook pour utiliser les analytics n'importe où dans l'application
export const useAnalytics = () => {
  // Si on est côté serveur (durant le build), retourner des valeurs par défaut
  if (typeof window === 'undefined') {
    return defaultContextValue;
  }

  // Sinon, continuer normalement
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return context;
};
